import { render, staticRenderFns } from "./CustomerCareForm.vue?vue&type=template&id=636c0c5d&scoped=true&"
import script from "./CustomerCareForm.vue?vue&type=script&lang=js&"
export * from "./CustomerCareForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCareForm.vue?vue&type=style&index=0&id=636c0c5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c0c5d",
  null
  
)

export default component.exports